const sortNumber = (array, parameter, direction) => {
  const arr = [...array];
  if (direction === 'asc_') {
    return arr.sort((a, b) => a[parameter] - b[parameter]);
  }
  return arr.sort((a, b) => b[parameter] - a[parameter]);
};

export default sortNumber;
